import { reportingDashboardConstants } from '../_constants';

const {
	GET_REPORT_COUNT_START,
	GET_REPORT_COUNT_SUCCESS,
	GET_REPORT_COUNT_FAILED,
	FILTER_COUNT_START,
	FILTER_COUNT_SUCCESS,
	FILTER_COUNT_FAILED,
} = reportingDashboardConstants;

const initialState = {
	countLoading: false,
	error: false,
	countSummary: {
		total: 0,
		totalSuccess: 0,
		totalFailed: 0,
		totalPending: 0,
		totalUnprocessed: 0
	},
	filteredCountSummary: {
		total: 0,
		totalSuccess: 0,
		totalFailed: 0,
		totalPending: 0,
		totalUnprocessed: 0
	},
};

const ReportingDashboardCountReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case GET_REPORT_COUNT_START:
			return {
				...state,
				countLoading: true,
			};
		case GET_REPORT_COUNT_SUCCESS:
			const { total, totalSuccess, totalFailed, totalPending, totalUnprocessed } =
				payload;
			return {
				...state,
				countLoading: false,
				countSummary: {
					total: total,
					totalSuccess: totalSuccess,
					totalFailed: totalFailed,
					totalPending: totalPending,
					totalUnprocessed: totalUnprocessed
				},
			};
		case GET_REPORT_COUNT_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		case FILTER_COUNT_START:
			return { ...state, countLoading: true };
		case FILTER_COUNT_SUCCESS:
			const {
				total: filteredTotal,
				totalSuccess: filteredSuccessfulCount,
				totalFailed: filteredFailedCount,
				totalPending: filteredPendingCount,
				totalUnprocessed: filteredUnprocessedCount
			} = payload;
			return {
				...state,
				countLoading: false,
				filteredCountSummary: {
					total: filteredTotal,
				totalSuccess: filteredSuccessfulCount,
				totalFailed: filteredFailedCount,
				totalPending: filteredPendingCount,
				totalUnprocessed: filteredUnprocessedCount
				},
			};
		case FILTER_COUNT_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		default:
			return state;
	}
};

export default ReportingDashboardCountReducer;
